export { default } from './PromotionDetailContainer';
